const iraConsentTemplate = `
<pwr-ira-consent-component
    groupId="ctrl.groupId"
    individualId="ctrl.individualId"
    goToNextLocation = "ctrl.goToNextLocation"
></pwr-ira-consent-component>
`;
export default iraConsentTemplate;